import { Type } from 'class-transformer';

import { IHandoverBrief } from './cargo-handover';
import { ISenderPrivacy } from './sender-privacy';
import { IPagination, IQueryPaginationDto } from './utils';

export class IZPLPackage {
  ZPL: string;
}

export class IPackage {
  id: number;
  /** Listede BE relationships.externalCargo'dan istemci tarafında bağlanır */
  externalCargo?: IHandoverBrief | null;
  /** Listede relationships.point/subCity'den istemci tarafında çözülür (harici kargo firma kapsamı) */
  toCityId?: number | null;
  barcode: string;
  boxcode: string;
  calculatePrice: number;
  compSpecialCode: string | null;
  compSpecialCode2: string | null;
  compSpecialCode3: string | null;
  company_id: string | number;
  companyId: string | number;
  create_type: string;
  date: string; // ISO date string
  createDate: string; // ISO date string
  deliveryDate: string | null;
  fromId: string | number;
  toId: string | number;
  signerName: string | null;
  status: number;
  ftl: string | null;
  height: number | null;
  iadecode: string | null;
  insurance: string;
  insurances_list_id: string | number;
  is_return_package: number;
  job_day: string | null;
  length: number | null;
  notiffer: number;
  pack_type_id: number;
  payment_options: number;
  price: number;
  priceDesi: number | null;
  priceDivisor: number | null;
  price_ins: number;
  price_type: string;
  special_price: number | null;
  extra_km_price: number | null;
  extra_km_price_ins: number | null;
  effective_price: number | null;
  effective_price_ins: number | null;
  effective_price_source: EffectivePriceSource | null;
  insurance_rate: number | null;
  price_locked: number;
  invoice_no: string | null;
  return_why: string | null;
  route_message: string;
  route_ok: number;
  sefer_id: string | number;
  shipping_type: number;
  size_sign: string;
  supercharge: string;
  totalDesi: number;
  total_weight: string;
  vendorn: number;
  virtual_package: string | null;
  width: number | null;
  processingDate: string | Date;
  lastProcessingDate: string | Date;
  /** Gönderici gizleme — visible=false ise korunan tarafın id'si null */
  senderPrivacy?: ISenderPrivacy | null;
}

export class IPackageResponse {
  @Type(() => IPackage)
  result: IPackage;
  /** Harici kargo (aktif ya da son teslim edilmiş devir) — K7 */
  externalCargo?: IHandoverBrief | null;
}

export class IZPLPackageResponse {
  @Type(() => IZPLPackage)
  result: IZPLPackage;
}

export class IPackageListResponse extends IPagination {
  @Type(() => IPackage)
  results: IPackage[];
  relationships?: { externalCargo?: Record<string, IHandoverBrief> } & Record<string, unknown>;
}

export class IPackageQueryDto extends IQueryPaginationDto {
  status?: string | number;
  toName?: string;
  toId?: string | number;
  statuses?: number[];
  companyName?: string;
  barcodeSearch?: string;
  barcode?: string;
  dateCreatedStart?: string;
  dateCreatedEnd?: string;
  irsaliyeSearch?: string;
  ilId?: string;
  sessionId?: string;
  companyId?: (string | number)[];
  companyIdNotIn?: (string | number)[];
  shippingType?: number;
  shippingTypes?: number[];
  containerId?: string;
  dateStart?: string;
  dateEnd?: string;
  fromName?: string;
  fromilId?: string;
  irsaliyeFastSearch?: string;
  irsaliyeSearch3Month?: string;
  returnType?: string;
  externalCargo?: boolean | string;
  iadecode?: string;
  desiMin?: string;
  desiMax?: string;
  // Fiyat override filtresi: any | special | extra_km | manual
  priceOverride?: string;
}

export class IPatchPackageBodyDto {
  barcode?: string;
  boxcode?: string;
  calculatePrice?: number;
  compSpecialCode?: string;
  compSpecialCode2?: string;
  compSpecialCode3?: string;
  companyId?: number;
  createType?: string;
  createDate?: string;
  data?: string;
  deliveryDate?: string;
  fromId?: number;
  toId?: number;
  signerName?: string;
  status?: number;
  ftl?: string;
  group_barcode?: string;
  height?: number;
  iadecode?: string;
  insurance?: string;
  insurances_list_id?: number;
  is_return_package?: number;
  job_day?: number;
  length?: number;
  notiffer?: number;
  pack_type_id?: number;
  payment_options?: string;
  price?: number;
  priceDesi?: number;
  priceDivisor?: number;
  price_ins?: number;
  price_type?: string;
  return_why?: string;
  route_message?: string;
  route_ok?: number;
  sefer_id?: number;
  shipping_type?: number;
  size_sign?: string;
  supercharge?: string;
  totalDesi?: number;
  totalWeight?: number;
  vendorn?: number;
  virtual_package?: number;
  width?: number;
  lastProcessingDate?: string;
  processingDate?: string;
  doc_number?: string;
  /** Gönderici gizleme: true gizle, false göster, null firma ayarına uy; gönderilmezse değişmez */
  senderHidden?: boolean | null;
}

export class IPostPackgeBodyDto {
  plaka: string | null;
  container_id: string | null;
  barcode?: string;
  boxcode?: string;
  calculatePrice?: number;
  compSpecialCode?: string;
  compSpecialCode2?: string;
  compSpecialCode3?: string;
  companyId?: string | number;
  createType?: string;
  createDate?: string;
  date?: string;
  deliveryDate?: string;
  fromId?: string | number;
  toId?: string | number;
  signerName?: string;
  status?: number;
  ftl?: string;
  group_barcode?: string;
  height?: number;
  iadecode?: string;
  insurance?: string;
  insurances_list_id?: string | number;
  is_return_package?: number;
  job_day?: number;
  length?: number;
  notiffer?: number;
  pack_type_id?: string | number;
  payment_options?: string;
  price?: number;
  priceDesi?: number;
  priceDivisor?: number;
  price_ins?: number;
  price_type?: string;
  return_why?: string;
  route_message?: string;
  route_ok?: number;
  sefer_id?: number;
  shipping_type?: number;
  size_sign?: string;
  supercharge?: string;
  totalDesi?: number;
  totalWeight?: number;
  vendorn?: number;
  virtual_package?: number;
  width?: number;
  lastProcessingDate?: string;
  processingDate?: string;
  doc_number?: string;
  /** Gönderici gizleme: yalnız kullanıcı değiştirdiyse gönderilir (yoksa firma ayarı) */
  senderHidden?: boolean;
}

export class IOldReturnPackages {
  id: number;
  vendorId: string;
  returnDate: string;
  lastDate: string;
  why: string;
  status: number;
  type: number;
  barcode: string;
  company: number;
  code: string;
  userId: number;
  desi: number;
  route: number;
  logisticDesc: string;
  lat: string;
  loc: string;
}

export class IOldReturnPackagesResponse {
  @Type(() => IOldReturnPackages)
  result: IOldReturnPackages;
}

export class IOldReturnPackagesListResponse extends IPagination {
  @Type(() => IOldReturnPackages)
  results: IOldReturnPackages[];
}

export class IOldReturnPackagesQueryDto extends IQueryPaginationDto {
  vendorId?: number;
  company?: number;
  status?: number;
  type?: number;
  userId?: number;
  route?: number;
  barcode?: string;
  code?: string;
}

export class IPackageByCompanyIdStatistics {
  results: {
    company_id: number;
    statistics: {
      today: ShippingResultItem[];
      oneWeek: ShippingResultItem[];
    };
  }[];
}

export class IPackageByVendorIdStatistics {
  results: {
    point_id: number;
    statistics: {
      today: ShippingResultItem[];
      oneWeek: ShippingResultItem[];
    };
  }[];
}

interface ShippingResultItem {
  status: number;
  shipping_type: number;
  count: number;
}

export class IPackageMyXDockStatistics {
  results: PackageMyXDockItem[];
}
export interface PackageMyXDockItem {
  point_id: number;
  total_count: number;
  total_deci: number;
  statistics: StatisticsMyXDock[];
}
export interface StatisticsMyXDock {
  id: number;
  adet: number;
  desi: number;
  pointName: string;
  hidden: number;
  routeid: number;
  sessionid: number;
  createdate: string;
  lastupdate: string;
}

export class IPackageCheckBarcodeResponse {
  result: {
    isOk: boolean;
  };
}

// ── Geçerli (effective) fiyat kaynağı ──
export type EffectivePriceSource = 'CALCULATED' | 'MANUAL' | 'SPECIAL';

export const effectivePriceSourceLabels: Record<EffectivePriceSource, string> = {
  CALCULATED: 'Otomatik',
  MANUAL: 'Elle Normal',
  SPECIAL: 'Özel Fiyat'
};

export const effectivePriceSourceColors: Record<EffectivePriceSource, string> = {
  CALCULATED: 'blue',
  MANUAL: 'orange',
  SPECIAL: 'magenta'
};

// Elle fiyat düzenleme gövdesi. Alan gönderilmezse değişmez; null = temizle.
export interface IManualPricePayload {
  normalPrice?: number;
  specialPrice?: number | null;
  extraKmPrice?: number | null;
  note?: string;
}

export type PackagePriceLogField = 'normal' | 'special' | 'extra_km' | 'reset';

export const packagePriceLogFieldLabels: Record<PackagePriceLogField, string> = {
  normal: 'Elle Normal Fiyat',
  special: 'Özel Fiyat',
  extra_km: 'Ek KM Fiyatı',
  reset: 'Sıfırlama'
};

export interface IPackagePriceLog {
  id: string;
  packageId: number;
  barcode?: string;
  field: PackagePriceLogField;
  oldValue: number | null;
  newValue: number | null;
  oldEffective: number | null;
  newEffective: number | null;
  sourceBefore?: string;
  sourceAfter?: string;
  userId: number;
  userName: string;
  note?: string;
  createdAt: string;
}

export interface IPackagePriceLogsResponse {
  result: IPackagePriceLog[];
}
